import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { App } from "./App";
export function AppRouter() {
  return <BrowserRouter data-id="element-21">
          <Routes data-id="element-22">
            <Route path="/" element={<App data-id="element-24" />} data-id="element-23" />
          </Routes>
      </BrowserRouter>;
}